<template>
  <div class="content">
    <div class="page-title flex align-center just-content-between">
      <div class="flex">
        <p>{{ pageTitle }}</p>
        <p class="u-ml30">{{ tabs + 1 }} / {{ tabsMax + 1 }}</p>
      </div>
      <div class="flex align-center u-ml40 u-mr20" style="font-size: 14px">
        <span class="icon">
          <font-awesome-icon icon="user" size="2x"></font-awesome-icon>
        </span>
        <p class="u-mr10 u-ml5 u-mb0">{{ schoolYear }}</p>
        <p class="u-mb0">{{ childName }}</p>
      </div>
    </div>
    <p class="prohibited-text">
      ※ブラウザの戻るボタン/再読み込みは使用しないでください。<br />入力中のデータが正しく処理されません。
    </p>
    <div class="form-wrap">
      <div class="tab -0" v-if="tabs === 0">
        <atoms-input-text
          class="u-mb30"
          label="記入者："
          type="text"
          placeholder="記入者"
          inputmode="text"
          :required="false"
          v-model="formData.writer"
          setKey="writer"
          @input-emit="handleUpdateValue"
        ></atoms-input-text>
        <section class="form-section u-mb20">

          <atoms-label label="身辺処理" class="u-mb15" />

          <atoms-input-select
            class="u-mt15"
            label="食事"
            v-model="formData.affairsProcessingMeal"
            setKey="affairsProcessingMeal"
            :options="useDefine.defineObject.AFFAIRSPROCESSING_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="排泄"
            v-model="formData.affairsProcessingExcretion"
            setKey="affairsProcessingExcretion"
            :options="useDefine.defineObject.AFFAIRSPROCESSING_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="衣服着脱"
            v-model="formData.affairsProcessingClothesDetachable"
            setKey="affairsProcessingClothesDetachable"
            :options="useDefine.defineObject.AFFAIRSPROCESSING_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="入浴"
            v-model="formData.affairsProcessingBathing"
            setKey="affairsProcessingBathing"
            :options="useDefine.defineObject.AFFAIRSPROCESSING_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="身だしなみ"
            v-model="formData.affairsProcessingGrooming"
            setKey="affairsProcessingGrooming"
            :options="useDefine.defineObject.AFFAIRSPROCESSING_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="生理の始末"
            v-model="formData.affairsProcessingSettlementOfPhysiological"
            setKey="affairsProcessingSettlementOfPhysiological"
            :options="useDefine.defineObject.AFFAIRSPROCESSING_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="服薬・健康管理"
            v-model="formData.affairsProcessingMedicationHealthManagement"
            setKey="affairsProcessingMedicationHealthManagement"
            :options="useDefine.defineObject.AFFAIRSPROCESSING_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-textarea
            label="具体的な様子"
            placeholder="具体的な様子"
            :required="false"
            v-model="formData.affairsProcessingSpecificSituation"
            setKey="affairsProcessingSpecificSituation"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>

          <atoms-input-textarea
            label="その他支援が必要な状況"
            placeholder="その他支援が必要な状況"
            :required="false"
            v-model="formData.affairsProcessingOtherAssistance"
            setKey="affairsProcessingOtherAssistance"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>
        </section>
      </div>

      <div class="tab -1" v-if="tabs === 1">
        <div class="u-mb40">
          <p class="u-mt20 u-mb10 bold">コミュニケーション</p>

          <atoms-input-select
            class="u-mt0"
            label="意思表示の手段・程度"
            v-model="formData.communicationManifestationOfIntention"
            setKey="communicationManifestationOfIntention"
            :options="
              useDefine.defineObject.MANIFESTATIONOFINTENTION_OPTION_ARRAY
            "
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="他者からの意思伝達の理解"
            v-model="formData.communicationUnderstandingOfCommunication"
            setKey="communicationUnderstandingOfCommunication"
            :options="
              useDefine.defineObject.UNDERSTANDINGOFCOMMUNICATION_OPTION_ARRAY
            "
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-textarea
            label="具体的な様子"
            placeholder="具体的な様子"
            :required="false"
            v-model="formData.communicationSpecificSituation"
            setKey="communicationSpecificSituation"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>

          <atoms-input-textarea
            label="その他支援が必要な状況"
            placeholder="その他支援が必要な状況"
            :required="false"
            v-model="formData.communicationOtherAssistance"
            setKey="communicationOtherAssistance"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>
        </div>

        <div class="u-mb20">
          <p class="u-mt0 u-mb10 bold">日常生活</p>
          <atoms-input-select
            class="u-mt0"
            label="洗濯"
            v-model="formData.everydayLifeWashing"
            setKey="everydayLifeWashing"
            :options="useDefine.defineObject.EVERYDAYLIFE_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="掃除"
            v-model="formData.everydayLifeCleanUp"
            setKey="everydayLifeCleanUp"
            :options="useDefine.defineObject.EVERYDAYLIFE_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="整理・整頓"
            v-model="formData.everydayLifeOrganizeAndTidy"
            setKey="everydayLifeOrganizeAndTidy"
            :options="useDefine.defineObject.EVERYDAYLIFE_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="買物"
            v-model="formData.everydayLifeShopping"
            setKey="everydayLifeShopping"
            :options="useDefine.defineObject.EVERYDAYLIFE_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="調理"
            v-model="formData.everydayLifeCooking"
            setKey="everydayLifeCooking"
            :options="useDefine.defineObject.EVERYDAYLIFE_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-textarea
            label="具体的な様子"
            placeholder="具体的な様子"
            :required="false"
            v-model="formData.everydayLifeSpecificSituation"
            setKey="everydayLifeSpecificSituation"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>
        </div>
      </div>

      <div class="tab -2" v-if="tabs === 2">
        <div class="u-mb40">
          <p class="u-mt20 u-mb10 bold">社会生活</p>

          <atoms-input-select
            class="u-mt0"
            label="屋外移動"
            v-model="formData.socialLifeOutdoorMovement"
            setKey="socialLifeOutdoorMovement"
            :options="useDefine.defineObject.OUTDOORMOVEMENT_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="対人関係"
            v-model="formData.socialLifeInterpersonalRelations"
            setKey="socialLifeInterpersonalRelations"
            :options="
              useDefine.defineObject
                .INTERPERSONALRELATIONSANDMONEYMANAGEMENT_OPTION_ARRAY
            "
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="金銭管理"
            v-model="formData.socialLifeMoneyManagement"
            setKey="socialLifeMoneyManagement"
            :options="
              useDefine.defineObject
                .INTERPERSONALRELATIONSANDMONEYMANAGEMENT_OPTION_ARRAY
            "
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="文字"
            v-model="formData.socialLifeLetter"
            setKey="socialLifeLetter"
            :options="useDefine.defineObject.LETTER_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="集団"
            v-model="formData.socialLifeGroup"
            setKey="socialLifeGroup"
            :options="useDefine.defineObject.GROUP_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-select
            label="時間"
            v-model="formData.socialLifeTime"
            setKey="socialLifeTime"
            :options="useDefine.defineObject.TIME_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
          ></atoms-input-select>

          <atoms-input-textarea
            label="具体的な様子"
            placeholder="具体的な様子"
            :required="false"
            v-model="formData.socialLifeSpecificSituation"
            setKey="socialLifeSpecificSituation"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>
        </div>

        <div class="u-mb40">
          <p class="u-mt0 u-mb10 bold">
            要配慮行動<br />（ほぼ毎日あり→◎／週1、2回程度あり→○／週1回未満→△／なし→×）
          </p>
          <atoms-input-radio-block
            label="強いこだわり"
            v-model="formData.socialLifeConsiderationBehaviorStrongCommitment"
            setKey="socialLifeConsiderationBehaviorStrongCommitment"
            :options="useDefine.defineObject.SYMBOLSELECTION_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio-block>

          <atoms-input-radio-block
            label="多動"
            v-model="formData.socialLifeConsiderationBehaviorHyperactivity"
            setKey="socialLifeConsiderationBehaviorHyperactivity"
            :options="useDefine.defineObject.SYMBOLSELECTION_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio-block>

          <atoms-input-radio-block
            label="パニック"
            v-model="formData.socialLifeConsiderationBehaviorPanic"
            setKey="socialLifeConsiderationBehaviorPanic"
            :options="useDefine.defineObject.SYMBOLSELECTION_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio-block>

          <atoms-input-radio-block
            label="睡眠障害"
            v-model="formData.socialLifeConsiderationBehaviorSleepingDisorder"
            setKey="socialLifeConsiderationBehaviorSleepingDisorder"
            :options="useDefine.defineObject.SYMBOLSELECTION_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio-block>

          <atoms-input-radio-block
            label="食事・排泄に係る不適応行動"
            v-model="
              formData.socialLifeConsiderationBehaviorMaladaptativeBehavior
            "
            setKey="socialLifeConsiderationBehaviorMaladaptativeBehavior"
            :options="useDefine.defineObject.SYMBOLSELECTION_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio-block>

          <atoms-input-radio-block
            label="自傷他害"
            v-model="formData.socialLifeConsiderationBehaviorSelfHarmOtherHarm"
            setKey="socialLifeConsiderationBehaviorSelfHarmOtherHarm"
            :options="useDefine.defineObject.SYMBOLSELECTION_OPTION_ARRAY"
            @input-emit="handleUpdateValue"
            :is-tap="true"
          ></atoms-input-radio-block>

          <atoms-input-textarea
            label="具体的な様子"
            placeholder="具体的な様子"
            :required="false"
            v-model="formData.socialLifeConsiderationBehaviorSpecificSituation"
            setKey="socialLifeConsiderationBehaviorSpecificSituation"
            @input-emit="handleUpdateValue"
          ></atoms-input-textarea>
        </div>
      </div>

      <div class="check_button_wrap prev_and_next">
        <div class="prev">
          <atoms-note-button
            v-if="tabs > tabsMin"
            buttonText="前の項目へ"
            @confirm="handlePrevTabs"
          />
        </div>
        <div class="next">
          <atoms-note-button
            v-if="tabs < tabsMax"
            buttonText="次の項目へ"
            @confirm="handleNextTabs"
          />
        </div>
      </div>
    </div>
    <div class="form-tabs" v-if="nextPageTitle">
      <atoms-note-button
        :buttonText="`${nextPageTitle}へ`"
        @confirm="handleUpdateFormTab"
      />
    </div>
  </div>
</template>

<script>
import { defineObject } from '@/lib/define/use-define'
import formUtils from '@/lib/formUtils/form-utils'

export default {
  data() {
    return {
      tabsMin: 0,
      tabsMax: 2,
      tabs: 0,
      // formの選択肢
      useDefine: { defineObject: defineObject },
      // emit対象のformデータ
      formData: {
        createdDate: '',
        lastName: '',
        firstName: '',
        writer: '',
        affairsProcessingMeal: '',
        affairsProcessingExcretion: '',
        affairsProcessingClothesDetachable: '',
        affairsProcessingBathing: '',
        affairsProcessingGrooming: '',
        affairsProcessingSettlementOfPhysiological: '',
        affairsProcessingMedicationHealthManagement: '',
        affairsProcessingSpecificSituation: '',
        affairsProcessingOtherAssistance: '',
        communicationManifestationOfIntention: '',
        communicationUnderstandingOfCommunication: '',
        communicationSpecificSituation: '',
        communicationOtherAssistance: '',
        everydayLifeWashing: '',
        everydayLifeCleanUp: '',
        everydayLifeOrganizeAndTidy: '',
        everydayLifeShopping: '',
        everydayLifeCooking: '',
        everydayLifeSpecificSituation: '',
        socialLifeOutdoorMovement: '',
        socialLifeInterpersonalRelations: '',
        socialLifeMoneyManagement: '',
        socialLifeLetter: '',
        socialLifeGroup: '',
        socialLifeTime: '',
        socialLifeSpecificSituation: '',
        socialLifeConsiderationBehaviorStrongCommitment: '',
        socialLifeConsiderationBehaviorHyperactivity: '',
        socialLifeConsiderationBehaviorPanic: '',
        socialLifeConsiderationBehaviorSleepingDisorder: '',
        socialLifeConsiderationBehaviorMaladaptativeBehavior: '',
        socialLifeConsiderationBehaviorSelfHarmOtherHarm: '',
        socialLifeConsiderationBehaviorSpecificSituation: '',
      },
    }
  },
  props: {
    propsFormData: {
      type: Object,
      required: true,
    },
    setObjectKey: {
      type: String,
      required: true,
    },
    pageTitle: {
      type: String,
      required: true,
    },
    nextPageTitle: {
      type: String,
      required: false,
    },
    childName: {
      type: String,
      required: false,
    },
    schoolYear: {
      type: String,
      required: false,
    },
  },
  methods: {
    handleUpdateValue(setKey, setVal) {
      this.formData[setKey] = setVal
      this.$emit('input-emit', this.setObjectKey, setKey, setVal)
    },
    handlePrevTabs() {
      this.handleSmoothScroll()
      this.tabs--
    },
    handleNextTabs() {
      this.handleSmoothScroll()
      this.tabs++
    },
    handleSmoothScroll() {
      this.$smoothScroll({
        scrollTo: document.getElementById('app'), // scrollTo is also allowed to be number
      })
    },
    handleUpdateFormTab() {
      this.$emit('click-tab-switch', this.setObjectKey)
    },
  },
  mounted() {
    Object.keys(this.formData).forEach(key => {
      if (this.propsFormData[key]) {
        this.formData[key] = this.propsFormData[key]
      }

      this.handleUpdateValue(key, this.formData[key])
    })

    if (!this.formData.createdDate) {
      this.formData.createdDate = formUtils.handleSetJapaneseCalendar(
        new Date(),
        '',
        'none'
      )
      this.handleUpdateValue('createdDate', this.formData.createdDate)
    }
  },
}
</script>
<style lang="scss" scoped>
.form-tabs {
  margin: 0 auto;
  max-width: 460px;
  button {
    width: 100%;
  }
}
</style>
